<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b('', { variant })">
    <div :class="b('content')">
      <span
        :class="b('icon')"
        aria-hidden="true"
        v-html="displayedIcons[variant]"
      ></span>

      <div :class="b('info')">
        <h3 :class="b('title')">{{ $t(title) }}</h3>
        <p :class="b('description')">{{ $t(description) }}</p>

        <div v-if="tags.length" :class="b('tags')">
          <span v-for="tag in tags" :key="tag" :class="b('tag')">{{
            $t(tag)
          }}</span>
        </div>
      </div>
    </div>

    <UIButton
      v-if="actionLabel"
      :class="b('action')"
      :label="actionLabel"
      view="main"
      @click="$emit('action')"
    />
  </div>
</template>
